import query from './headers.graphql';

export const setHeaders = (cache, req) => {
  const data = req ? req.headers : {};
  cache.writeQuery({
    query,
    data: { headers: data },
  });
};
